// context/ProductContext.jsx
import { createContext, useState } from "react";

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  // Keep track of original inventory
  const [originalInventory, setOriginalInventory] = useState([]);

  const initializeInventory = (productsData) => {
    setProducts(productsData);
    setOriginalInventory(JSON.parse(JSON.stringify(productsData))); // Deep copy
  };

  return (
    <ProductContext.Provider value={{
      products,
      setProducts,
      originalInventory,
      initializeInventory
    }}>
      {children}
    </ProductContext.Provider>
  );
};